import { render } from "./AuSwitch.vue?vue&type=template&id=ffc23192&scoped=true"
import script from "./AuSwitch.vue?vue&type=script&lang=js"
export * from "./AuSwitch.vue?vue&type=script&lang=js"

import "./AuSwitch.vue?vue&type=style&index=0&id=ffc23192&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc23192"]])

export default __exports__